var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var StoryChaptersState_1;
import { State, Action, Selector, Store } from '@ngxs/store';
import { StoryChaptersStateModel } from './story.chapters.state.model';
import { SetChapters, SelectChapter, NextChapter, PreviousChapter, LastChapter, FirstChapter, RemoveChapter, RecordChapterVisibilityState, ResetStoryChapters, SetChapter, RegisterChapterThumbnails, TakeChapterPicture, TakeChapterPictureSuccess, RecordChapterPaintState, SaveLiveToChapter, DuplicateChapter, CopyThumbnail, RecordChapterCamera, RecordShadowChapter, SetChapterBackground, SetAllChaptersBackground, SetSelectedChapterBackground, ResetSelectedChapterBackground, RecordChapterPickableState, RecordChapterNodeState, SelectChapterById, SetChapterModfied, ResetChaptersModfied, } from './story.chapters.actions';
import { ChapterService } from '../../chapter.service';
import { RemoveAllChapterLabels, CopyLabels } from '../labels/story.labels.actions';
import { CameraService } from 'src/app/engine/camera.service';
import { classToClass } from 'class-transformer';
import { SnapshotService } from 'src/app/engine/snapshot.service';
import { ColorRecipeModel } from 'src/app/edit/models/color-recipe.model';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { EngineState } from 'src/app/engine/state/engine.state';
import { SetVisible } from 'src/app/engine/state/engine.actions';
import { StoryChapterThumbnail } from '../../models/story-chapter-thumbnail.model';
import { get, cloneDeep } from 'lodash';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { appDefaultBackground } from 'src/app/dialogs/components/background-color-dialog/background-config';
import { ThumbnailConstants } from 'src/app/shared/thumbnail.constants';
import { ImageTypeEnum } from 'src/app/shared/image.service';
import { AnimationService } from 'src/app/engine/animation.service';
// snapshot config
const defaultSnapshotConfig = {
    imageType: ImageTypeEnum.JPEG,
    copyrightEnabled: false,
    copyrightImagePath: 'assets/images/powered-by-biodigital.png',
    copyrightPosition: {
        x: 'center',
        y: 'bottom'
    },
    copyrightOffset: {
        x: 0,
        y: -15
    },
    imageQuality: 1.0
};
const initialState = {
    loading: false,
    chapters: [],
    chaptersModified: {},
    selectedChapter: null,
    shadowChapter: null,
    isChapterAnimated: false,
    thumbnails: new Map()
};
let StoryChaptersState = StoryChaptersState_1 = class StoryChaptersState {
    constructor(chapterService, cameraService, snapshotService, store, graphService, animationService) {
        this.chapterService = chapterService;
        this.cameraService = cameraService;
        this.snapshotService = snapshotService;
        this.store = store;
        this.graphService = graphService;
        this.animationService = animationService;
    }
    /**
     * Selectors
     */
    static getStoryChapters(state) {
        return state.chapters;
    }
    static getSelectedChapterId(state) {
        return state.selectedChapter;
    }
    static getSelectedChapter(state) {
        return state.chapters.find(chapter => chapter.id === state.selectedChapter) || null;
    }
    static getSelectedChapterIndex(state) {
        return state.chapters.findIndex(chapter => chapter.id === state.selectedChapter);
    }
    static getSelectedChapterModified(state) {
        return state.chaptersModified[state.selectedChapter] === true;
    }
    static getChapterCount(state) {
        return state.chapters.length;
    }
    static getRegisteredThumbnails(state) {
        return state.thumbnails;
    }
    static getShadowChapter(state) {
        return state.shadowChapter;
    }
    static getIsChapterAnimated(state) {
        return state.isChapterAnimated;
    }
    static getChaptersLoaded(state) {
        return {
            count: state.chapters.length,
            modelChapters: state.chapters.filter(chapter => chapter.readyState.model),
            animationChapters: state.chapters.filter(chapter => chapter.readyState.animation)
        };
    }
    static getAllChaptersModelsReady(state) {
        return state.chapters.length > 0 && state.chapters.every(chapter => chapter.readyState.model);
    }
    static getAllChaptersAnimationsReady(state) {
        return state.chapters.length > 0 && state.chapters.every(chapter => chapter.readyState.animation);
    }
    static getSelectedChapterBackground(state) {
        const { chapters, selectedChapter } = state;
        const chapter = StoryChaptersState_1.findChapter(chapters, selectedChapter);
        return get(chapter, 'background') || appDefaultBackground;
    }
    static getAllChaptersBackground(state) {
        return state.chapters
            .map((chapter) => get(chapter, 'background'));
    }
    static getSelectedChapterAudio(state) {
        const selectedChapter = state.chapters.find(chapter => chapter.id === state.selectedChapter);
        if (selectedChapter && selectedChapter.media) {
            const media = selectedChapter.media;
            const audioClips = Object.values(media)
                .filter(({ data }) => data.streamType === 'audio');
            return audioClips[0];
        }
        else {
            return null;
        }
    }
    static findChapter(chapters, chapterId) {
        return chapters
            .find((chapter) => chapter.id === chapterId);
    }
    /**
     * Actions
     */
    setChapters(context, action) {
        context.patchState({
            chapters: [...action.chapters]
        });
    }
    setChapter(context, action) {
        const chapters = context.getState().chapters;
        const index = chapters.findIndex((_chapter) => _chapter.id === action.chapter.id);
        const chapter = chapters[index];
        if (JSON.stringify(chapter) !== JSON.stringify(action.chapter)) {
            chapters[index] = Object.assign({}, action.chapter);
            context.patchState({
                chapters: [...chapters]
            });
        }
    }
    setChapterBackground(context, action) {
        const { chapters } = context.getState();
        context.patchState({
            chapters: chapters.map(chapter => {
                if (chapter.id === action.chapterId) {
                    chapter.background = action.background;
                }
                return chapter;
            })
        });
    }
    setAllChaptersBackground(context, { background }) {
        const chapters = context.getState().chapters;
        chapters.forEach((chapter) => {
            chapter.background = background;
        });
        context.patchState({
            chapters: [...chapters]
        });
    }
    resetSelectedChapterBackground(context, action) {
        const { selectedChapter, shadowChapter } = context.getState();
        this.store.dispatch(new SetChapterBackground(selectedChapter, shadowChapter.background));
    }
    setSelectedChapterBackground(context, { background }) {
        const chapterId = context.getState().selectedChapter;
        this.store.dispatch(new SetChapterBackground(chapterId, background));
    }
    // #NOTE: [EM] Change selected chapter id and make copy for shadowChapter
    selectChapter(context, action) {
        if (!action.chapter) {
            return;
        }
        const isAnimated = this.animationService.isChapterAnimated(action.chapter);
        this.store.dispatch(new SetVisible(action.chapter ? true : false));
        context.patchState({
            selectedChapter: action.chapter ? action.chapter.id : null,
            shadowChapter: action.chapter ? classToClass(action.chapter) : null,
            isChapterAnimated: isAnimated
        });
    }
    selectChapterById(context, { chapterId }) {
        this.store.dispatch(new SetVisible(true));
        context.patchState({
            selectedChapter: chapterId
        });
    }
    // Add Shadow Chapter, which captures changes to engine state, to the Story
    saveLiveToChapter(context, action) {
        // identify target chapter id
        const targetChapterId = action.chapterId ? action.chapterId : context.getState().selectedChapter;
        // replace specified chapter with shadowChapter
        const shadowChapter = context.getState().shadowChapter;
        const chapters = context.getState().chapters;
        const index = chapters.findIndex((_chapter) => _chapter.id === targetChapterId);
        const targetChapter = Object.assign({}, chapters[index], classToClass(shadowChapter));
        targetChapter.camera.location = this.cameraService.getCamera();
        chapters[index] = targetChapter;
        this.chapterService.replaceEngineChapterWithStateChapter(chapters[index]);
        context.patchState({
            chapters: [...chapters]
        });
    }
    duplicateChapter(context, action) {
        // create a safe chapter copy
        const copyFromShadow = action.chapter ? false : true;
        const sourceChapter = copyFromShadow ? context.getState().shadowChapter : action.chapter;
        const targetChapter = this.chapterService.copyChapter(sourceChapter);
        // insert chapter copy into ENGINE
        const chapters = context.getState().chapters;
        const insertIndex = action.location ? Math.min(action.location, chapters.length) : chapters.length;
        // #NOTE: [EM] deep copy is important. Otherwise engine replaces timeline map object.
        this.chapterService.addChapterToEngine(cloneDeep(targetChapter), insertIndex);
        // update application STATE
        chapters[insertIndex] = targetChapter;
        context.patchState({
            chapters: [...chapters]
        });
        context.dispatch(new CopyLabels(sourceChapter, targetChapter));
        context.dispatch(new CopyThumbnail(copyFromShadow ? null : sourceChapter, targetChapter));
    }
    copyThumbnail(context, action) {
        // copy thumbnail or take new snapshot for target chapter
        const thumbnails = context.getState().thumbnails;
        let targetThumbnail = new StoryChapterThumbnail();
        if (action.sourceChapter) {
            // copy, and point snapshot to original large url
            const sourceThumbnail = thumbnails.get(action.sourceChapter.id);
            targetThumbnail = classToClass(sourceThumbnail);
            targetThumbnail.urls.small = targetThumbnail.urls.small.replace(action.sourceChapter.id, action.targetChapter.id);
            targetThumbnail.urls.large = targetThumbnail.urls.large.replace(action.sourceChapter.id, action.targetChapter.id);
            if (sourceThumbnail.snapshot) {
                targetThumbnail.snapshot = sourceThumbnail.snapshot;
            }
            else {
                targetThumbnail.snapshot = thumbnails.get(action.sourceChapter.id).urls.large;
            }
            thumbnails.set(action.targetChapter.id, targetThumbnail);
            context.patchState({
                thumbnails: new Map(thumbnails)
            });
        }
        else {
            // take a snapshot
            context.dispatch(new TakeChapterPicture(action.targetChapter.id));
        }
    }
    nextChapter(context, action) {
        const chapters = context.getState().chapters;
        const currentChapterId = this.chapterService.getCurrentChapterId();
        let index = 0;
        index = chapters.findIndex(chapter => chapter.id === currentChapterId);
        if (index < chapters.length - 1) {
            index++;
        }
        context.dispatch(new SelectChapter(chapters[index]));
    }
    previousChapter(context, action) {
        const chapters = context.getState().chapters;
        const currentChapterId = this.chapterService.getCurrentChapterId();
        let index = 0;
        index = chapters.findIndex(chapter => chapter.id === currentChapterId);
        if (index > 0) {
            index--;
        }
        context.dispatch(new SelectChapter(chapters[index]));
    }
    lastChapter(context, action) {
        const chapters = context.getState().chapters;
        context.dispatch(new SelectChapter(chapters[chapters.length - 1]));
    }
    firstChapter(context, action) {
        const chapters = context.getState().chapters;
        context.dispatch(new SelectChapter(chapters[0]));
    }
    removeChapter(context, action) {
        const { chapters, selectedChapter } = context.getState();
        // Don't allow the user to remove the last chapter,
        // or else the system will break. 
        if (chapters.length === 1) {
            return;
        }
        // Trigger a rebuild of the chapter object in the engine before updating the application. 
        this.chapterService.removeChapterFromEngine(action.chapter);
        // Update chapters array
        let chapterIndex = chapters.findIndex(chapter => chapter.id === action.chapter.id);
        chapters.splice(chapterIndex, 1);
        context.patchState({
            chapters: [...chapters]
        });
        // Selected chapter deleted, need to select a new chapter by default
        if (action.chapter.id === selectedChapter) {
            // Make sure selected chapter doesn't exceed chapter array size
            if (chapterIndex === chapters.length) {
                chapterIndex--;
            }
            context.dispatch(new SelectChapter(chapters[chapterIndex]));
        }
        // Nuke all chapter labels
        context.dispatch(new RemoveAllChapterLabels(action.chapter));
    }
    resetStoryChaptersState(context, action) {
        context.setState(initialState);
    }
    recordShadowChapter(context, action) {
        context.patchState({
            shadowChapter: classToClass(action.chapter)
        });
    }
    recordChapterVisibilityState(context, action) {
        this.store.dispatch(new RecordChapterNodeState(action.nodes, { 'shown': action.visible }, action.record));
    }
    // record chagnes to shadowObject and conditionally to current chapter
    recordChapterPaintState(context, action) {
        // get shadow chapter
        const shadowChapter = context.getState().shadowChapter;
        // get view graph and filter nodes for subsumption (deeper nodes subsumed by shallower nodes)
        const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        const accessorIds = this.graphService.filterGraphAccessors(viewGraph, action.nodes.map((node) => node.id));
        // update the state record of chapter. Clear color mods beneath accessors, so they do not block this paint state
        let chapterSync = shadowChapter.synchronization;
        accessorIds.forEach((id) => {
            // clear color mods on deeper nodes in the graph
            chapterSync = this.chapterService.clearColorModsFromSync(chapterSync, this.graphService.getDescendants(viewGraph, id));
            // set the synchronization on the subsuming accessor
            chapterSync[id] = Object.assign({}, chapterSync[id] || {}, ColorRecipeModel.toEngine(action.paintState));
        });
        // update the engine's record
        shadowChapter.synchronization = Object.assign({}, chapterSync); // needs new object
        // patch state with updated stateful chapter record
        context.patchState({
            shadowChapter: classToClass(shadowChapter)
        });
        // conditionally save with current story chapter
        if (action.record) {
            const chapters = context.getState().chapters;
            const currentChapterId = context.getState().selectedChapter;
            const currentChapterIndex = chapters.findIndex((_chapter) => _chapter.id === currentChapterId);
            const chapter = chapters[currentChapterIndex];
            this.chapterService.updateChapterSynchronization(chapter.id, shadowChapter.synchronization);
            chapter.synchronization = Object.assign({}, shadowChapter.synchronization);
            context.patchState({
                chapters: [...chapters]
            });
        }
    }
    recordChapterCamera(context, action) {
        const camera = Object.assign({}, action.camera);
        // get shadow chapter
        const shadowChapter = context.getState().shadowChapter;
        // record change on shadow chapter if it matches the chapter being changed
        if (shadowChapter.id === action.chapter.id) {
            shadowChapter.camera.location = camera;
            // patch state with updated stateful chapter record
            context.patchState({
                shadowChapter: classToClass(shadowChapter)
            });
        }
        // conditionally save with current story chapter
        if (action.record) {
            const chapters = context.getState().chapters;
            const currentChapterIndex = chapters.findIndex((_chapter) => _chapter.id === action.chapter.id);
            const chapter = chapters[currentChapterIndex];
            if (action.chapter.id === shadowChapter.id) {
                this.chapterService.updateChapterSynchronization(chapter.id, shadowChapter.synchronization);
            }
            chapter.camera.location = Object.assign({}, action.camera);
            context.patchState({
                chapters: [...chapters]
            });
        }
    }
    recordChapterPickableState(context, action) {
        this.store.dispatch(new RecordChapterNodeState(action.nodes, { 'pickable': action.pickable }, action.record));
    }
    recordChapterNodeState(context, action) {
        // get shadow chapter
        const shadowChapter = context.getState().shadowChapter;
        // get view graph and filter nodes for subsumption (deeper nodes subsumed by shallower nodes)
        const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        const accessorIds = this.graphService.filterGraphAccessors(viewGraph, action.nodes.map((node) => node.id));
        // update shadow chapter synchronzation
        let chapterSync = shadowChapter.synchronization;
        accessorIds.forEach((id) => {
            Object.entries(action.stateMap).forEach(([propName, propValue]) => {
                // clear color mods on deeper nodes in the graph
                chapterSync = this.chapterService.clearBoolStateFromSync(chapterSync, this.graphService.getDescendants(viewGraph, id), propName);
                // set the synchronization on the subsuming accessor
                chapterSync[id] = Object.assign({}, chapterSync[id] || {}, { [propName]: propValue });
            });
        });
        // patch state with updated stateful chapter record
        context.patchState({
            shadowChapter: classToClass(shadowChapter)
        });
        // conditionally save with current story chapter
        if (action.record) {
            const chapters = context.getState().chapters;
            const currentChapterId = context.getState().selectedChapter;
            const currentChapterIndex = chapters.findIndex((_chapter) => _chapter.id === currentChapterId);
            const chapter = chapters[currentChapterIndex];
            this.chapterService.updateChapterSynchronization(chapter.id, shadowChapter.synchronization);
            chapter.synchronization = Object.assign({}, shadowChapter.synchronization);
            context.patchState({
                chapters: [...chapters]
            });
        }
    }
    registerChapterThumbnails(context, action) {
        // urls that came with scene for managing and housekeeping of server thumbnails per chapter
        context.patchState({
            thumbnails: new Map(action.thumbnails)
        });
    }
    takeChapterSnapshot(context, { chapterId, includeLabels, includeCopyright, dimensions }) {
        // get target dimensions: fallback to default
        const snapshotDimensions = dimensions ? dimensions : ThumbnailConstants.large;
        const { width, height } = snapshotDimensions;
        // get selected background
        const selectedBackground = this.store.selectSnapshot(StoryChaptersState_1.getSelectedChapterBackground);
        const snapshotBackground = selectedBackground && !BackgroundModel.isTransparent(selectedBackground) ? selectedBackground : appDefaultBackground;
        const snapshotConfig = Object.assign({}, defaultSnapshotConfig, { copyrightEnabled: includeCopyright });
        this.snapshotService.takeSnapshot(width, height, snapshotBackground, includeLabels, snapshotConfig).subscribe((blob) => {
            context.dispatch(new TakeChapterPictureSuccess(chapterId, blob, snapshotDimensions));
        });
    }
    takeChapterSnapshotSuccess(context, action) {
        const thumbnails = context.getState().thumbnails;
        const thumbnail = thumbnails.get(action.chapterId) || new StoryChapterThumbnail();
        thumbnail.snapshot = URL.createObjectURL(action.blob);
        thumbnails.set(action.chapterId, thumbnail);
        context.patchState({
            thumbnails: new Map(thumbnails)
        });
    }
    setChaptersModfied(context, { chapterId, modified }) {
        const chapterModified = context.getState().chaptersModified;
        context.patchState({
            chaptersModified: Object.assign({}, chapterModified, { [chapterId]: modified })
        });
    }
    ResetChaptersModfied(context, action) {
        context.patchState({
            chaptersModified: {}
        });
    }
};
__decorate([
    Action(SetChapters),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetChapters]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "setChapters", null);
__decorate([
    Action(SetChapter),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetChapter]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "setChapter", null);
__decorate([
    Action(SetChapterBackground),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetChapterBackground]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "setChapterBackground", null);
__decorate([
    Action(SetAllChaptersBackground),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "setAllChaptersBackground", null);
__decorate([
    Action(ResetSelectedChapterBackground),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ResetSelectedChapterBackground]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "resetSelectedChapterBackground", null);
__decorate([
    Action(SetSelectedChapterBackground),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "setSelectedChapterBackground", null);
__decorate([
    Action(SelectChapter),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SelectChapter]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "selectChapter", null);
__decorate([
    Action(SelectChapterById),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "selectChapterById", null);
__decorate([
    Action(SaveLiveToChapter),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SaveLiveToChapter]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "saveLiveToChapter", null);
__decorate([
    Action(DuplicateChapter),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, DuplicateChapter]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "duplicateChapter", null);
__decorate([
    Action(CopyThumbnail),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, CopyThumbnail]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "copyThumbnail", null);
__decorate([
    Action(NextChapter),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, NextChapter]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "nextChapter", null);
__decorate([
    Action(PreviousChapter),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, PreviousChapter]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "previousChapter", null);
__decorate([
    Action(LastChapter),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, LastChapter]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "lastChapter", null);
__decorate([
    Action(FirstChapter),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, LastChapter]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "firstChapter", null);
__decorate([
    Action(RemoveChapter),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, RemoveChapter]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "removeChapter", null);
__decorate([
    Action(ResetStoryChapters),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ResetStoryChapters]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "resetStoryChaptersState", null);
__decorate([
    Action(RecordShadowChapter),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, RecordShadowChapter]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "recordShadowChapter", null);
__decorate([
    Action(RecordChapterVisibilityState),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, RecordChapterVisibilityState]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "recordChapterVisibilityState", null);
__decorate([
    Action(RecordChapterPaintState),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, RecordChapterPaintState]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "recordChapterPaintState", null);
__decorate([
    Action(RecordChapterCamera),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, RecordChapterCamera]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "recordChapterCamera", null);
__decorate([
    Action(RecordChapterPickableState),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, RecordChapterPickableState]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "recordChapterPickableState", null);
__decorate([
    Action(RecordChapterNodeState),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, RecordChapterNodeState]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "recordChapterNodeState", null);
__decorate([
    Action(RegisterChapterThumbnails),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, RegisterChapterThumbnails]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "registerChapterThumbnails", null);
__decorate([
    Action(TakeChapterPicture),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, TakeChapterPicture]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "takeChapterSnapshot", null);
__decorate([
    Action(TakeChapterPictureSuccess),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, TakeChapterPictureSuccess]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "takeChapterSnapshotSuccess", null);
__decorate([
    Action(SetChapterModfied),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, SetChapterModfied]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "setChaptersModfied", null);
__decorate([
    Action(ResetChaptersModfied),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, ResetChaptersModfied]),
    __metadata("design:returntype", void 0)
], StoryChaptersState.prototype, "ResetChaptersModfied", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getStoryChapters", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getSelectedChapterId", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getSelectedChapter", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getSelectedChapterIndex", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getSelectedChapterModified", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getChapterCount", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getRegisteredThumbnails", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getShadowChapter", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getIsChapterAnimated", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getChaptersLoaded", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getAllChaptersModelsReady", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getAllChaptersAnimationsReady", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getSelectedChapterBackground", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getAllChaptersBackground", null);
__decorate([
    Selector(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [StoryChaptersStateModel]),
    __metadata("design:returntype", void 0)
], StoryChaptersState, "getSelectedChapterAudio", null);
StoryChaptersState = StoryChaptersState_1 = __decorate([
    State({
        name: 'storyChapters',
        defaults: initialState
    }),
    __metadata("design:paramtypes", [ChapterService,
        CameraService,
        SnapshotService,
        Store,
        BdGraphService,
        AnimationService])
], StoryChaptersState);
export { StoryChaptersState };
